import { render } from "./RoundedButton.vue?vue&type=template&id=e868d4aa"
import script from "./RoundedButton.vue?vue&type=script&lang=js"
export * from "./RoundedButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__